import {
  portalLink,
  UserInitialSection,
  UserInitialsItem,
} from '@monash/portal-frontend-common';
import { Icon } from '@monash/portal-react';
import React from 'react';

/**
 * Returns Home's custom user menu sections.
 *
 * This is returned as an array of UserInitialSection components rather than as a single React component
 * because the User Initials menu checks that its children are UserInitialSection components before mutating them via cloneElement.
 * These mutations via React.cloneElement are currently necessary for the menu to function. Therefore, until this typecheck +
 * dependency on cloneElement is removed, UserInitialsSection components cannot be wrapped in another React component before being
 * passed as children to the User Initials menu.
 *
 * TODO: Removing the use of cloneElement in the User Initials components requires a fundamental refactor
 */
const getUserInitialsCustomSections = ({ setShowThemer }) => {
  const profileSection = (
    <UserInitialSection key="profile">
      <UserInitialsItem
        href={portalLink('profile')}
        text="View my profile"
        icon={<Icon.Id />}
      />
      <UserInitialsItem
        href={portalLink('profile', 'course-progress')}
        text="Course progress"
        icon={<Icon.Ready />}
      />
    </UserInitialSection>
  );

  const themerSection = (
    <UserInitialSection key="themer">
      <UserInitialsItem
        onClick={() => {
          setShowThemer(true);
        }}
        text="Themer"
        icon={<Icon.Wand />}
        rightIcon={<Icon.Copy />}
      />
    </UserInitialSection>
  );

  return [profileSection, themerSection];
};

export default getUserInitialsCustomSections;
